import { tns } from "tiny-slider";

export default el => {

	if (el instanceof HTMLElement) {
		const sliderContainer = el.querySelector(".slider");
		const isInNeosBackend = ("neos" in window);

		const isAutoPlay = (!isInNeosBackend && (!!el.dataset.autoplay));
		const autoplayTimeout = el.dataset.sliderTimer ? el.dataset.sliderTimer* 1000 :  5000;
		const useDotsNavigation = !!el.dataset.sliderUsedots;

		const prevButton = el.querySelector("[data-sliderNav=prevBtn]");
		const nextButton = el.querySelector("[data-sliderNav=nextBtn]");

		if (sliderContainer) {
			const slider = tns({
				container: sliderContainer,
				nav: useDotsNavigation,
				items: 1,
				gutter: 24,
				swipeAngle: false,
				navAsThumbnails: true,
				loop: (!isInNeosBackend),
				autoplay: isAutoPlay,
				autoplayTimeout: autoplayTimeout,
				autoplayHoverPause: true,
				autoplayButton: false,
				autoplayButtonOutput: false,
				center: !isInNeosBackend,
				navPosition: "bottom",
				prevButton: prevButton,
				nextButton: nextButton,
				mouseDrag: true,
				useLocalStorage: false,
			});

			prevButton.onclick = function () {
				const info = slider.getInfo();
				updateVideoFrame(info, info.indexCached);
			}

			nextButton.onclick = function () {
				const info = slider.getInfo();
				updateVideoFrame(info, info.indexCached);
			};
		}
	}
}

function updateVideoFrame(info, index) {
	if (!!info.slideItems[index].dataset.component && info.slideItems[index].dataset.component === 'VideoSlider') {
		const videoContainer = info.slideItems[index].querySelector('[data-video=container]');
		const videoPlayer = videoContainer.querySelector('video');

		if (videoPlayer) {
			videoPlayer.pause();
			videoPlayer.currentTime = 0;
		}
		videoContainer?.classList.add("videoFrameHidden");
	}
}
